import { getRevenueModelDefaults } from 'states/resources/campaigns/business-logic';

export const openCampaignDuplicateModal = campaign => {
    return dispatch => {
        dispatch({
            type: 'CAMPAIGN_DUPLICATE_MODAL__INIT',
            payload: {
                campaign: campaign,
            },
        });
    };
};

export const campaignFormUpdate = changes => {
    return dispatch => {
        dispatch({
            type: 'CAMPAIGN_DUPLICATE_MODAL__DRAFT_UPDATE',
            payload: {
                changes: changes,
            },
        });
    };
};

export const changeRevenueModel = value => {
    const defaults = getRevenueModelDefaults(value);
    return dispatch => {
        dispatch(campaignFormUpdate(defaults));
    };
};

export const closeCampaignDuplicateModal = () => {
    return dispatch => {
        dispatch({
            type: 'CAMPAIGN_DUPLICATE_MODAL__CLOSE_MODAL',
        });
    };
};

export const loadOrganizations = ({ ownOrganization, organizations }) => {
    return dispatch => {
        dispatch({
            type: 'CAMPAIGN_DUPLICATE_MODAL__LOAD_ORGANIZATION',
            payload: {
                ownOrganization,
                organizations,
            },
        });
    };
};

export const initSuccess = (campaign, campaignClients, creatorId) => {
    const campaignWithClients = {
        ...campaign,
        clients: campaignClients,
    };
    return dispatch => {
        dispatch({
            type: 'CAMPAIGN_DUPLICATE_MODAL__INIT_SUCCESS',
            payload: {
                campaign: campaignWithClients,
                creatorId,
            },
        });
    };
};

export const duplicateCampaign = (campaignId, payload) => {
    return dispatch => {
        dispatch({
            type: 'CAMPAIGN_DUPLICATE_MODAL__CONFIRM_START',
            payload: {
                campaignId: campaignId,
                ...payload,
            },
        });
    };
};
